module.exports = __webpack_public_path__ + "static/media/twitter.2d4b6be3.svg";